import { BaseQuantity } from "../../interface/functionalityInterface";
// Derived base quantity
// coherent SI unit is F
export const Capacitance: BaseQuantity = {
  id: "001capacitance",
  name: "capacitance",
  type: "numeric",
  value: "",
  symbol: "C",
  baseUnit: "F",
  selectedUnit: "F",
  units: [
    { name: "F", fromConst: 1, toConst: 1 },
    { name: "\u00B5F", fromConst: 1 / 10 ** 6, toConst: 10 ** 6 },
    { name: "n\u00b2", fromConst: 1 / 10 ** 9, toConst: 10 ** 9 },
    { name: "p\u00b2", fromConst: 1 / 10 ** 12, toConst: 10 ** 12 },
  ],
};
